import { render, staticRenderFns } from "./IbInvoiceTypeLookup.vue?vue&type=template&id=8e96f5ba&scoped=true"
import script from "./IbInvoiceTypeLookup.vue?vue&type=script&lang=js"
export * from "./IbInvoiceTypeLookup.vue?vue&type=script&lang=js"
import style0 from "./IbInvoiceTypeLookup.vue?vue&type=style&index=0&id=8e96f5ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e96f5ba",
  null
  
)

export default component.exports